import {
  FETCH_TOTEM_REPORTS_REQUEST,
  FETCH_TOTEM_REPORTS_SUCCESS,
  FETCH_TOTEM_REPORTS_ERROR,
  FETCH_TOTEM_REPORTS_CANCEL,
  FETCH_TOTEM_REPORTS_CSV_REQUEST,
  FETCH_TOTEM_REPORTS_CSV_SUCCESS,
  FETCH_TOTEM_REPORTS_CSV_ERROR,
  FETCH_TOTEM_REPORTS_CSV_CANCEL,
} from 'actionTypes'

const DEFAULT_STATE = {
  records: [],
  error: null,
  isFetching: false,
  csvFile: "",
}

const record = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_TOTEM_REPORTS_REQUEST:
      return {
        ...state,
        isFetching: true,
      }

    case FETCH_TOTEM_REPORTS_CANCEL:
      return {
        ...state,
        isFetching: false,
        error: null,
      }

    case FETCH_TOTEM_REPORTS_SUCCESS:
      return {
        isFetching: false,
        error: null,
        records: action.payload,
      }

    case FETCH_TOTEM_REPORTS_ERROR:
      return {
        isFetching: false,
        records: [],
        error: action.payload,
      }
    
    case FETCH_TOTEM_REPORTS_CSV_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };

    case FETCH_TOTEM_REPORTS_CSV_CANCEL:
      return {
        ...state,
        isFetching: false,
        error: null,
      };

    case FETCH_TOTEM_REPORTS_CSV_SUCCESS:
      return {
        isFetching: false,
        error: null,
        records: Array.isArray(action.payload) ? action.payload : state.records, 
        csvFile: typeof action.payload === "string" ? action.payload : state.csvFile, 
      };

    case FETCH_TOTEM_REPORTS_CSV_ERROR:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };

    default:
      return state
  }
}

export default record
